/**
 * The anonymous sentinel's id, mirrored from the API.
 *
 * MUST match `GUEST_USER_ID` in `apps/api/src/modules/users/guest.ts`
 * (`${APP_SHORTNAME}${IdPrefix.USER}:guest`). An unauthenticated caller gets a
 * *user* with this id rather than a 401, so "logged out" is a specific id, not
 * a missing user.
 *
 * Compared with `===`, exactly as the API does. A substring test would
 * misclassify any genuine account whose random suffix happened to contain
 * "guest" — ids draw 11 characters from a mixed-case alphanumeric alphabet, so
 * that is rare but perfectly possible, and the failure mode here is worse than
 * on the server: the auth guard would bounce that user to `/login`, the login
 * would succeed, and the guard would bounce them again. A permanent loop out of
 * which the user cannot click.
 */
export const GUEST_USER_ID = 'dcusr:guest';

/** True when the id is the anonymous sentinel. */
export const isGuestId = (id: string | undefined | null): boolean => id === GUEST_USER_ID;
